import React, { useState, useEffect } from 'react';
import styles from './Header.module.scss';

import { ArrowDownCircle } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

import ModalePromo from '../ModalePromo/ModalePromo'; // chemin à adapter selon ton projet

const h1Texts = [
  "Un logo unique, à l'image de votre entreprise ?",
  "Vous avez une idée innovante ?",
  "Besoin d'une présence en ligne ?"
];

const pTexts = [
  "Nous créons le logo qui vous représente vraiment, et bien plus encore...!",
  "Nous créons votre prototype d'application en un temps record !",
  "Nous vous proposons un site web adapté à vos exigences."
];

const Header = () => {
  const [index, setIndex] = useState(0);

  const [showPromo, setShowPromo] = useState(false);

  useEffect(() => {
    const textTimer = setInterval(() => {
      setIndex((prev) => (prev + 1) % h1Texts.length);
    }, 3000);

    // const promoTimer = setTimeout(() => {
    //   setShowPromo(true);
    // }, 1000); // par exemple, après 4s

    return () => {
      clearInterval(textTimer);
      // clearTimeout(promoTimer);
    };
  }, []);

  const variants = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -30 }
  };

  return (
    <header id="home" className={styles.header}>
      <div className={styles.headerContent}>
        <div className={styles.textContainer}>
          <AnimatePresence mode="wait">
            <motion.h1
              key={h1Texts[index]}
              variants={variants}
              initial="initial"
              animate="animate"
              exit="exit"
              transition={{ duration: 0.5 }}
            >
              {h1Texts[index]}
            </motion.h1>
          </AnimatePresence>

          <div className={styles.spacer}></div>

          <AnimatePresence mode="wait">
            <motion.p
              key={pTexts[index]}
              variants={variants}
              initial="initial"
              animate="animate"
              exit="exit"
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              {pTexts[index]}
            </motion.p>
          </AnimatePresence>
        </div>

        <div className={styles.buttonContainer}>
          <a href="#services" className={styles.neonBtn}>Découvrez nos services</a>
          <a href="contact" className={styles.contactBtn}>Un projet ? Contactez-nous !</a>
        </div>
        
      </div>

      <div className={styles.arrow}>
        <a href="#services">
          <ArrowDownCircle className={styles.customIcon} size={180} />
        </a>
      </div>

      <div className={styles.addon}>
        <blockquote>
          &ldquo;&nbsp;Si j'avais demandé aux gens ce qu'ils voulaient, ils m'auraient dit : des chevaux plus rapides.&nbsp;&rdquo; -
          <span className="text-bold"> Henry Ford</span>
        </blockquote>
      </div>

      {showPromo && <ModalePromo onClose={() => setShowPromo(false)} />}
    </header>
  );
};

export default Header;
